import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from '../../../redux/store/store'
import "./ItemsScheduleNotification.css"
import ItemScheduleNotification from '../ItemScheduleNotification/ItemScheduleNotification'
import { DeleteScheduleNotificationsThunk } from '../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'
import { deleteScheduleNotifications } from '../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import { useNavigate } from 'react-router-dom'

const ItemsScheduleNotification = () => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const items = useSelector((state: RootState) => state.scheduleNotificationsData.items)

    const onDelete = useCallback(
        (id: string) => {
            dispatch( DeleteScheduleNotificationsThunk(id) )
        },
        [],
    )

        
    const onSave = useCallback(
        () => {
            
        },
        [],
    )
    
    const onGoEdit = useCallback(
        (id: string) => {
            navigate(`/schedule-notifications/${id}`)   
        },
        [],
    )
    

    return (
        <div className="p-relative flex-1" style={{ width: "100%", minHeight: "54rem" }}>
            <div className="aux-scroll">
                {
                    items.map((item) => {
                        return (
                            <ItemScheduleNotification 
                                key={item.id}
                                item={item}
                                onDelete={onDelete}
                                onSave={onSave}
                                onPress={onGoEdit}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default React.memo( ItemsScheduleNotification )